import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';

import { useIntl } from '../../../../../util/reactIntl';
import { OutsideClickHandler, IconGuests } from '../../../../../components';

import { MdPeopleAlt } from 'react-icons/md';
import css from './FilterGuests.module.css';

const FilterGuests = props => {
  const {
    name = 'guests',
    minGuests = 1,
    maxGuests = 6,
    className,
    rootClassName,
    alignLeft,
  } = props;

  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const classes = classNames(rootClassName || css.root, className);

  const quantities = useMemo(() => {
    const arr = [];
    for (let i = minGuests; i <= maxGuests; i++) arr.push(i);
    return arr;
  }, [minGuests, maxGuests]);

  return (
    <Field name={name} subscription={{ value: true }}>
      {({ input }) => {
        const value = input.value ?? null;

        const label = value
          ? intl.formatMessage({ id: 'BookingDatesForm.guestsOption' }, { guests: value })
          : intl.formatMessage({ id: 'FilterGuests.selectQuantityOption' });
        
        const title = intl.formatMessage({ id: 'FilterGuests.title' });

        const labelClasses = classNames(css.label, {
          [css.active]: value || isOpen,
        });

        const selectGuests = g => {
          input.onChange(g);
          setIsOpen(false);
        };

        const clearGuests = () => {
          input.onChange(null);
          setIsOpen(false);
        };

        return (
          <OutsideClickHandler className={classes} onOutsideClick={() => setIsOpen(false)}>
            <div
              role="button"
              className={css.toggleButton}
              onClick={() => setIsOpen(prev => !prev)}
              tabIndex={0}
              onKeyDown={() => setIsOpen(prev => !prev)}
              aria-expanded={isOpen}
              aria-controls="guests-panel"
            >
              <div className={css.guestIcon}>
              <IconGuests rootClassName={css.customIconLocation} />
              </div>
             <div className={css.textContainer}>
                <span className={css.title}>{title}</span>
                <span className={`${labelClasses} ${css.block}`}>{label}</span>
              </div>
            </div>

            {isOpen ? (
              <div
                id="guests-panel"
                className={classNames(css.guestsPicker, { [css.alignLeft]: alignLeft })}
                role="listbox"
                aria-label="Guests"
              >
                <button type="button" className={css.clearRow} onClick={clearGuests}>
                  {intl.formatMessage({ id: 'FilterGuests.clear' }, { defaultMessage: 'Clear' })}
                </button>

                <div className={css.options}>
                  {quantities.map(g => {
                    const isSelected = Number(value) === g;
                    return (
                      <button
                        key={g}
                        type="button"
                        role="option"
                        aria-selected={isSelected}
                        className={classNames(css.option, { [css.optionSelected]: isSelected })}
                        onClick={() => selectGuests(g)}
                      >
                        {intl.formatMessage({ id: 'BookingDatesForm.guestsOption' }, { guests: g })}
                      </button>
                    );
                  })}
                </div>
              </div>
            ) : null}
          </OutsideClickHandler>
        );
      }}
    </Field>
  );
};

export default FilterGuests;
